// Splits a stored transcript string into rendered entries. Each entry starts
// with a bracketed header the backend (and manual-input paths) write, e.g.
//   [Audio Note 06/24/2026 @ 13:19:47 by Power, Emilio] ...text...
// The time portion is optional, and its seconds component is optional too: the
// audio-save process stamps HH:mm:ss (real recording start, for distinctness),
// while manual/creation entries stamp HH:mm. The parser must accept both, or a
// seconds-stamped transcript yields zero entries and the text never renders.
export const parseTranscript = (text) => {
  const regex = /\[(?:(.+?) )?(\d{2}\/\d{2}\/\d{4}(?: @ \d{2}:\d{2}(?::\d{2})?)?)(?: by ([^\]]+))?\]\s*([\s\S]*?)(?=\n\[|$)/g;

  let entries = [];
  let index = 0;

  let match;
  while ((match = regex.exec(text)) !== null) {
    const info = match[1] || "Audio Note";
    const date = match[2];
    const author = match[3];
    const entryText = match[4];
    const fullMatch = match[0];

    entries.push({
      index,
      info,
      date,
      author,
      text: entryText,
      originalEntry: fullMatch,
    });

    index++;
  }

  return entries;
};
